/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Analysis } from "./Analysis";
import {
  AnalysisFromJSON,
  AnalysisFromJSONTyped,
  AnalysisToJSON,
  AnalysisToJSONTyped,
} from "./Analysis";

/**
 *
 * @export
 * @interface ApiGarAnalysesList200Response
 */
export interface ApiGarAnalysesList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarAnalysesList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarAnalysesList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarAnalysesList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Analysis>}
   * @memberof ApiGarAnalysesList200Response
   */
  results: Array<Analysis>;
}

/**
 * Check if a given object implements the ApiGarAnalysesList200Response interface.
 */
export function instanceOfApiGarAnalysesList200Response(
  value: object
): value is ApiGarAnalysesList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarAnalysesList200ResponseFromJSON(json: any): ApiGarAnalysesList200Response {
  return ApiGarAnalysesList200ResponseFromJSONTyped(json, false);
}

export function ApiGarAnalysesList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarAnalysesList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(AnalysisFromJSON),
  };
}

export function ApiGarAnalysesList200ResponseToJSON(json: any): ApiGarAnalysesList200Response {
  return ApiGarAnalysesList200ResponseToJSONTyped(json, false);
}

export function ApiGarAnalysesList200ResponseToJSONTyped(
  value?: ApiGarAnalysesList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(AnalysisToJSON),
  };
}
